<template>
  <div class="mw-screen">

    <!-- HEADER: point number label + circle -->
    <div class="mw-header-card">
      <p class="mw-point-label">{{ lang }}{{ translation.pointNumber }}</p>
      <div class="mw-point-circle" style="cursor:pointer" @click="$parent.slideMapInn()">
        {{ Object.values(points)[pointsArrayOrder[pointNum] - 1].pointNumber }}
      </div>
    </div>

    <!-- INSTRUCTION + IMAGE -->
    <div class="mw-content-card">
      <p class="mw-instruction">{{ translation.findMissingWord }}</p>
      <img id="imgUrl" class="mw-clue-image" :src="getImgUrl" />
    </div>

    <!-- INPUT ROW -->
    <div class="mw-input-row">
      <input class="mw-input" id="missingWordAnswer" v-model="missingWordAnswer"
        :placeholder="translation.translationMissingWord" name="missingWordAnswer" aria-describedby="missingWordAnswer"
        label="missingWordAnswer" required />
      <button class="mw-send-btn" @click="checkMissingWord">
        <!-- Send / paper-plane icon — pointing left (RTL) -->
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-send-fill"
          viewBox="0 0 16 16" style="transform: rotate(258deg)">
          <path
            d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
        </svg>
      </button>
    </div>

    <!-- SKIP BUTTON -->
    <div class="mw-skip-row">
      <button class="mw-skip-btn" @click="showAlertSkipPoint">
        <!-- Skip icon — flipped to point left (RTL) -->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
          class="bi bi-skip-forward-fill" viewBox="0 0 16 16" style="transform: scaleX(-1)">
          <path
            d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.753l-6.267 3.636c-.54.313-1.233-.066-1.233-.697v-2.94l-6.267 3.636C.693 12.703 0 12.324 0 11.693V4.308c0-.63.693-1.01 1.233-.696L7.5 7.248v-2.94c0-.63.693-1.01 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5z" />
        </svg>
        {{ translation.skipPoint }}
      </button>
    </div>

    <!-- SKIP ALERT OVERLAY -->
    <div v-if="alertSkipPoint" class="mw-overlay" @click.self="alertSkipPoint = false">
      <div class="mw-modal">
        <div class="mw-modal-icon">⚠️</div>
        <h3 class="mw-modal-title">{{ translation.skipPoint }}</h3>
        <p class="mw-modal-text">{{ translation.skipPointBeware }}</p>
        <button class="mw-modal-confirm" @click="skipPoint()">
          {{ translation.skipPoint }}
        </button>
        <button class="mw-modal-cancel" @click="alertSkipPoint = false">
          {{ translation.back }}
        </button>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  data() {
    return {
      missingWordAnswer: "",
      pointNum: this.$parent.pointNum,
      alertSkipPoint: false,
      activeClass: "activePoint",
      notActive: "smallPoint",
      // activeClassPoint: "activeClassPoint",
      notActivePoint: "numbersInCercle",
      slide: 0,
      sliding: null,
      key: "",
      translation: {
        back: "Fermer",
        skipPoint: "Passer au point suivant",
        findMissingWord:
          "Rends-toi sur place et trouve l'inscription qui se trouve sur l'image ci-dessous.",
        pointNumber: "Sur la carte, repérez le nº",
        translationMissingWord: "Mot manquant sur l'image",
        skipPointBeware:
          "Attention! Si vous ne trouvez pas la pancarte ou la réponse, vous pouvez passer au point suivant, cela vous coûtera 20 points.",
      },
      correctAnswerSound: require("../../static/sounds/correctAnswer.mp3"),
      wongAnswerSound: require("../../static/sounds/wrongAnswer.mp3"),
    };
  },
  mounted() { },
  computed: {
    getImgUrl() {
      const idx = this.pointsArrayOrder[this.pointNum] - 1;
      const cached = this.$store.getters.arrayOfImagesBase64;
      if (cached && cached[idx]) return cached[idx];
      const pt = Object.values(this.points)[idx];
      return pt?.imageBase64 || pt?.imageUrl || '';
    },
    lang() {
      console.log("this.$store.getters.lang", this.$store.getters.lang);
      return this.translate(this.$store.getters.lang);
    },
    pointsArrayOrder() {
      if (localStorage.getItem("pointsArrayOrder")) {
        return JSON.parse(localStorage.getItem("pointsArrayOrder"));
      } else {
        return this.$store.getters.pointsArrayOrder;
      }
    },
    points() {
      return this.$store.getters.points;
    },
  },

  methods: {
    checkMissingWord() {
      ////////CORRECT ANSWER///////////////////
      this.storePointNumber();
      var audio;
      if (
        this.missingWordAnswer.toLowerCase() ===
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .missingWord ||
        this.missingWordAnswer.toLowerCase().replace(/\s/g, "") ===
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .missingWord
      ) {
        this.$parent.checkElementPicked();
        this.$parent.errorNumber = this.$parent.errorNumber + 5;
        localStorage.setItem("errorNumber", this.$parent.errorNumber);
        this.$parent.showStarUp("5+");
        this.$parent.showCorrectAnswerIcon = true;

        document
          .getElementById("missingWordAnswer")
          .classList.add("greenBorder");
        audio = new Audio(this.correctAnswerSound);
        audio.play();
        setTimeout(() => {
          document
            .getElementById("missingWordAnswer")
            .classList.remove("greenBorder");
          this.missingWordAnswer = "";
          this.$parent.showPointInformation = true;
          this.$parent.showCorrectAnswerIcon = false;
          localStorage.setItem(
            "showPointInformation",
            this.$parent.showPointInformation
          );
          setTimeout(() => {
            this.$parent.showButtonInfoScreen = true;
          }, 2000);
          this.$parent.showPickedItem = false;
          localStorage.setItem("showPickedItem", this.$parent.showPickedItem);
          this.$parent.showMainScreen = false;
          localStorage.setItem("showMainScreen", this.$parent.showMainScreen);
        }, 1000);
        ////////WRONG ANSWER///////////////////
      } else {
        document.getElementById("missingWordAnswer").classList.add("redBorder");
        audio = new Audio(this.$parent.wongAnswerSound);
        audio.play();
        setTimeout(() => {
          document
            .getElementById("missingWordAnswer")
            .classList.remove("redBorder");
        }, 1000);
        // this.errorNumber++;
        this.$parent.errorNumber--;

        localStorage.setItem("errorNumber", this.$parent.errorNumber);
      }
    },
    storePointNumber() {
      localStorage.setItem("pointNumber", this.pointNum);
      localStorage.setItem(
        "pointNumForEvolution",
        this.$parent.pointNumForEvolution
      );
    },
    skipPoint() {
      this.$parent.checkElementPicked();
      this.storePointNumber();
      this.$parent.errorNumber = this.$parent.errorNumber - 20;
      localStorage.setItem("errorNumber", this.$parent.errorNumber);
      setTimeout(() => {
        localStorage.setItem(
          "showPointInformation",
          this.$parent.showPointInformation
        );
        document
          .getElementById("buttonContinueDisabled")
          .classList.remove("active");
        this.$parent.showButtonInfoScreen = true;
      }, 1000);
      this.$parent.showPointInformation = true;
      this.$parent.showPickedItem = false;
      localStorage.setItem("showPickedItem", this.showPickedItem);
      this.$parent.showMainScreen = false;
      localStorage.setItem("showMainScreen", this.showMainScreen);
      this.alertSkipPoint = false;
      // localStorage.setItem("firstQuestion", 1);
      this.$parent.startTime = this.$parent.startTime - 60 * 10 * 1000;
      this.$store.dispatch("addEvolutionToDB", {
        pointNumber: this.pointNum,
        userKey: this.userKey,
        navigationName: this.$parent.gameParameters.navigationName,
      });
    },
    showAlertSkipPoint() {
      this.alertSkipPoint = true;
    },
    checkAnswer(index, event) {
      // REPONSE EST JUSTE
      if (
        index ==
        this.arrayOfImages.indexOf(
          this.points[this.pointsArrayOrder[this.$parent.pointNum]].imageBase64
        )
      ) {
        event.target.parentElement.classList.add("greenBorder");
        this.$parent.errorNumber = this.$parent.errorNumber + 5;
        this.$parent.showStarUp("5+");
        this.$parent.showCorrectAnswerIcon = true;
        var audio = new Audio(this.correctAnswerSound);
        audio.play();
        this.$parent.checkElementPicked();
        localStorage.setItem("errorNumber", this.$parent.errorNumber);
        setTimeout(() => {
          this.$parent.showPointInformation = true;
          localStorage.setItem(
            "showPointInformation",
            this.$parent.showPointInformation
          );
          this.$parent.showCorrectAnswerIcon = false;
          this.$parent.showButtonInfoScreen = true;
          this.$parent.showPickedItem = false;
          localStorage.setItem("showPickedItem", this.showPickedItem);

          this.$parent.showMainScreen = false;
          localStorage.setItem("showMainScreen", this.showMainScreen);

          // this.nextPointNumber();
        }, 1000);

        // REPONSE EST FAUSSE
      } else {
        event.target.parentElement.classList.add("redBorder");
        this.$parent.errorNumber = this.$parent.errorNumber - 10;
        this.$parent.$refs.pointsCounting.classList.add("redColor");
        localStorage.setItem("errorNumber", this.$parent.errorNumber);
        this.$parent.showWongAnswerIcon = true;

        audio = new Audio(this.wongAnswerSound);
        audio.play();

        setTimeout(() => {
          //   console.log("b4 remove redborder");
          event.target.parentElement.classList.remove("redBorder");
          // this.$refs.checkAnswerButton.classList.remove("redBorder");
          this.$parent.$refs.pointsCounting.classList.remove("redColor");
          this.$parent.showWongAnswerIcon = false;
        }, 1000);
      }
    },
    translate(lang) {
      switch (lang) {
        case "fr":
          this.translation = {
            back: "Fermer",
            skipPoint: "Passer au point suivant",
            skipPointBeware:
              "Attention! Si vous ne trouvez pas la pancarte ou la réponse, vous pouvez passer au point suivant, cela vous coûtera 20 points.",
            findMissingWord:
              "Rends-toi sur place et trouve l'inscription qui se trouve sur l'image ci-dessous.",
            checkAnswer: "Vérifier",
            chooseImageSeen: "Depuis ce point, je vois le visuel ci-dessus",
            imageNumber: "Visuel nº",
            goThere: "Rends-toi sur place.",
            pointNumber: "Sur la carte, repérez le nº",

            translationMissingWord: "Mot manquant sur l'image",
          };
          break;
        case "he":
          this.translation = {
            back: "סגור",
            skipPoint: "דלג לנקודה הבאה",
            skipPointBeware:
              "שימו לב! אם אינכם מוצאים את השלט או את התשובה, תוכלו לדלג לנקודה הבאה, אך זה יעלה לכם 20 נקודות.",
            findMissingWord:
              "גשו למקום ומצאו את הכיתוב שמופיע בתמונה למטה.",
            checkAnswer: "בדוק תשובה",
            chooseImageSeen: "מנקודה זו אני רואה את התמונה שמעל",
            imageNumber: "תמונה מס׳",
            goThere: "גשו לשם.",
            pointNumber: "במפה, מצאו את המספר:",

            translationMissingWord: "מילה חסרה בתמונה",
          };
          break;
        case "en":
          this.translation = {
            back: "Close",
            skipPoint: "Skip to next point",
            skipPointBeware:
              "Warning! If you can't find the sign or the answer, you can skip to the next point, but it will cost you 20 points.",
            findMissingWord:
              "Go there and find the inscription shown in the image below.",
            checkAnswer: "Check answer",
            chooseImageSeen: "From this point, I can see the image above",
            imageNumber: "Image no.",
            goThere: "Go there.",
            pointNumber: "On the map, find the number:",
            translationMissingWord: "Missing word on the image",
          };
          break;
        case "de":
          this.translation = {
            back: "Schließen",
            skipPoint: "Zum nächsten Punkt",
            skipPointBeware:
              "Achtung! Wenn Sie das Schild oder die Antwort nicht finden, können Sie zum nächsten Punkt übergehen, aber das kostet Sie 20 Punkte.",
            findMissingWord:
              "Gehen Sie dorthin und finden Sie die Inschrift, die auf dem Bild unten zu sehen ist.",
            checkAnswer: "Überprüfen",
            chooseImageSeen: "Von diesem Punkt aus sehe ich das obige Bild",
            imageNumber: "Bild Nr.",
            goThere: "Gehe dorthin.",
            pointNumber: "Finde die Nummer auf der Karte:",
            translationMissingWord: "Fehlendes Wort auf dem Bild",
          };
          break;
        case "ar":
          this.translation = {
            back: "إغلاق",
            skipPoint: "تخطي إلى النقطة التالية",
            skipPointBeware:
              "تحذير! إذا لم تتمكن من إيجاد اللافتة أو الإجابة، يمكنك تخطي النقطة التالية، لكن ذلك سيكلفك 20 نقطة.",
            findMissingWord:
              "اذهب إلى المكان وابحث عن الكلمة الظاهرة في الصورة أدناه.",
            checkAnswer: "تحقق من الإجابة",
            chooseImageSeen: "من هذه النقطة، أرى الصورة أعلاه",
            imageNumber: "صورة رقم",
            goThere: "اذهب إلى هناك.",
            pointNumber: "على الخريطة، ابحث عن الرقم:",
            translationMissingWord: "الكلمة المفقودة في الصورة",
          };
          break;
        default:
          // Default to English if no language matches
          this.translation = {
            checkAnswer: "Check answer",
            chooseImageSeen: "From this point, I can see the image above",
            imageNumber: "Image no.",
            goThere: "Go there.",
            pointNumber: "On the map, find the number:",
            explaination:
              "Among the " +
              this.arrayOfImages.length +
              " images below, which one can you see from this point?",
          };
          console.log(`Language ${lang} not supported, defaulting to English.`);
      }
    },

    // onSlideStart() {
    //   this.sliding = true;
    // },
    // onSlideEnd() {
    //   this.sliding = false;
    // },
  },
};
</script>

<style scoped>
@font-face {
  font-family: VarelaRound;
  src: url(../../static/fonts/VarelaRound-Regular.ttf);
}

/* ── Root container ─────────────────────────────────────── */
.mw-screen {
  font-family: VarelaRound, sans-serif;
  color: white;
  min-height: 100vh;
  padding: 24px 16px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  width: 100%;
  max-width: 590px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* ── Header card ────────────────────────────────────────── */
.mw-header-card {
  /* background: rgba(120, 190, 255, 0.18); */
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(24px);
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  border-radius: 22px;
  padding: 18px 28px;
  text-align: center;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 4px 24px rgba(30, 100, 200, 0.15);
}

.mw-point-label {
  margin: 0 0 12px;
  font-size: 20px;
  color: white;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 4px rgba(0, 60, 150, 0.3);
}

.mw-point-circle {
  margin: 0 auto;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  border: 3px solid #38b2f8;
  background: linear-gradient(135deg, #e8f4ff, #cce9ff);
  font-size: 32px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1565c0;
  box-shadow: 0 2px 10px rgba(56, 178, 248, 0.3);
}

/* ── Content card (instruction + image) ─────────────────── */
.mw-content-card {
  /* background: rgba(120, 190, 255, 0.18); */
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(24px);
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  border-radius: 22px;
  padding: 20px 16px;
  width: 100%;
  max-width: 480px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(30, 100, 200, 0.15);
}

.mw-instruction {
  font-size: 18px;
  line-height: 1.5;
  margin: 0 0 16px;
  color: white;
  font-weight: 500;
  text-shadow: 0 1px 4px rgba(0, 60, 150, 0.25);
}

.mw-clue-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 420px;
  border-radius: 14px;
  border: 2px solid rgba(56, 178, 248, 0.35);
  box-shadow: 0 4px 20px rgba(30, 100, 200, 0.15);
}

/* ── Input row ──────────────────────────────────────────── */
.mw-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 480px;
}

.mw-input {
  flex: 1;
  height: 54px;
  border-radius: 50px;
  border: 2px solid rgba(56, 178, 248, 0.45);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: #1a2e4a;
  font-family: VarelaRound, sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 0 22px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(30, 100, 200, 0.1);
}

.mw-input::placeholder {
  color: rgba(37, 99, 176, 0.5);
  font-weight: 400;
}

.mw-input:focus {
  border-color: #38b2f8;
  box-shadow: 0 0 0 3px rgba(56, 178, 248, 0.2);
}

/* JS-added feedback classes */
:global(#missingWordAnswer.greenBorder) {
  border: 3px solid #22c55e !important;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.25) !important;
}

:global(#missingWordAnswer.redBorder) {
  border: 3px solid #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.25) !important;
}

.mw-send-btn {
  top: -2px;
  position: relative;
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: linear-gradient(135deg, #38b2f8, #1565c0);
  border: none;
  box-shadow: 0 4px 0 #0d4a9e, 0 6px 16px rgba(21, 101, 192, 0.35);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
}

.mw-send-btn:active {
  transform: translateY(3px);
  box-shadow: 0 1px 0 #0d4a9e, 0 2px 6px rgba(21, 101, 192, 0.2);
}

/* ── Skip row ───────────────────────────────────────────── */
.mw-skip-row {
  width: 100%;
  max-width: 480px;
  display: flex;
  justify-content: center;
}

.mw-skip-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(120, 190, 255, 0.18);
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  border-radius: 50px;
  color: white;
  font-family: VarelaRound, sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 22px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.mw-skip-btn:hover {
  background: rgba(56, 178, 248, 0.3);
  border-color: rgba(255, 255, 255, 0.8);
}

/* ── Skip alert overlay ─────────────────────────────────── */
.mw-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 10500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.mw-modal {
  background: #1c1c1e;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 32px 24px;
  max-width: 340px;
  width: 100%;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.mw-modal-icon {
  font-size: 52px;
  margin-bottom: 14px;
}

.mw-modal-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 12px;
  font-family: VarelaRound, sans-serif;
}

.mw-modal-text {
  font-size: 15px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.75);
  margin: 0 0 22px;
  font-weight: 400;
}

.mw-modal-confirm {
  width: 100%;
  padding: 14px;
  border-radius: 14px;
  border: none;
  background: #0a84ff;
  color: #fff;
  font-family: VarelaRound, sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 10px;
  transition: opacity 0.15s;
}

.mw-modal-confirm:active { opacity: 0.85; }

.mw-modal-cancel {
  width: 100%;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  font-family: VarelaRound, sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.15s;
}

.mw-modal-cancel:active { opacity: 0.7; }

</style>
